// @flow strict

import * as React from 'react';

import {usePointerDrag} from 'src/hooks/usePointerDrag';
import classify from 'src/utils/classify';

import HoverIconButton from 'src/components/lib/hover-icon-button';

import CancelIcon from 'src/images/icons/cancel-icon.svg';

import css from './popover.css';


export default function Popover({
  onClose,
  titleText,
  titleContent,
  children,
  className,
}: {
  onClose: () => mixed,
  titleText: string,
  titleContent?: React.Node,
  children: React.Node,
  className?: string,
}): React.Node {
  const positionRef = React.useRef({x: 0, y: 0});
  const rootRef = React.useRef<?HTMLElement>();
  const headerRef = React.useRef<?HTMLElement>();

  const [dragProps] = usePointerDrag({
    validateDownEvent: (event) => event.target === headerRef.current,
    onMove: ({deltaX, deltaY}) => {
      if (rootRef.current) {
        const position = positionRef.current;
        position.x += deltaX;
        position.y += deltaY;
        rootRef.current.style.transform = `translate(${positionRef.current.x}px, ${positionRef.current.y}px)`;
        document.body?.style.setProperty('cursor', 'grabbing');
      }
    },
    onDone: () => {
      document.body?.style.removeProperty('cursor');
    },
  });

  return (
    <div className={classify(css.root, className)} ref={rootRef}>
      <div className={css.header} {...dragProps}>
        <div className={css.draggable} ref={headerRef} />
        <div className={css.title}>
          <span>{titleText}</span>
          <HoverIconButton className={css.x} onClick={onClose}>
            <CancelIcon />
          </HoverIconButton>
        </div>
        {titleContent}
      </div>
      {children}
    </div>
  );
}
